import Cookies from 'js-cookie'

// 接口类方法
import WebviewInvokeApp from './api'
export default WebviewInvokeApp

// 从 APP Webview 的 Cookie 中获取 APP 最近一次连接的相机型号
export const getAppLastConnectCamera = function () {
  let camera = Cookies.get('insta_app_last_connect_camera_type')
  if (typeof camera === 'string' && camera !== '') {
    return camera
      .toLowerCase()
      .replace(/\s/gi, '')
      .replace(/insta360/gi, '')
  }
  return null
}

/**
 * IOS系统下webview在刘海屏上顶部padding大小
 * @returns {number} 顶部padding大小
 */
export function getIosTopPadding() {
  let padding = Cookies.get('insta_app_top_padding')
  if (padding) return parseInt(padding)
  return 0
}
